const API_BASE_URL = process.env.API_BASE_URL || "http://localhost:4000/api";

async function apiRequest(path, options = {}) {
  const token = localStorage.getItem("nyasa_token");
  let response;

  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers
      }
    });
  } catch (_error) {
    const localHint = API_BASE_URL.includes("localhost") ? " Start the API with npm run dev:api." : " Please try again in a moment.";
    throw new Error(`Cannot reach Nyasa API at ${API_BASE_URL}.${localHint}`);
  }

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.error?.message || `API request failed: ${response.status}`);
    error.code = payload.error?.code;
    error.status = response.status;
    throw error;
  }

  return payload;
}

export async function apiGet(path) {
  return apiRequest(path);
}

export async function apiPost(path, body) {
  return apiRequest(path, {
    method: "POST",
    body: JSON.stringify(body)
  });
}

export async function apiPostEmpty(path) {
  return apiRequest(path, {
    method: "POST"
  });
}

export async function apiPatch(path, body) {
  return apiRequest(path, {
    method: "PATCH",
    body: JSON.stringify(body)
  });
}

export async function apiDownload(path) {
  const token = localStorage.getItem("nyasa_token");
  const response = await fetch(`${API_BASE_URL}${path}`, {
    cache: "no-store",
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error?.message || `Download failed: ${response.status}`);
  }
  return response.blob();
}

export { API_BASE_URL };
